import React, { useEffect, useState } from 'react';
import Image from './Image';
import { ModalProvider } from '../../../Modal/modalContext';
import ProductButton from '../../../ProductModal/ProductButton';
import styles from './Image.module.scss';
import { generateKey, getCurrentVariant } from '../../../../functions';

const ImageRightPoints = ({ properties, type }) => {
  const [scrollY, setScrollY] = useState(0);
  const [isHidden, setIsHidden] = useState(false);
  const [hasScrolledDown, setHasScrolledDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);

      if (currentScrollY >= 350 && !hasScrolledDown) {
        setIsHidden(true);
        setHasScrolledDown(true);
      } else if (currentScrollY < 350 && hasScrolledDown) {
        setIsHidden(true);
        setHasScrolledDown(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolledDown]);
  return (
    !!properties?.image && (
      <>
        <div
          className={`${styles.imageWrapper} ${type == 'trends' ? '' : styles.imageButton} ${styles.imageWrapperWithButton} ${
            isHidden ? styles.hidden : ''
          }`}
        >
          <Image type="leftSide" properties={properties} />
        </div>
        {!!properties?.image?.imagePointsCoordinates &&
          properties.image.imagePointsCoordinates.map((point) => (
            <ModalProvider key={point?.id ?? generateKey()}>
              <ProductButton point={point} />
            </ModalProvider>
          ))}
        {!!properties?.image?.imagePointsYellow &&
          properties.image.imagePointsYellow.map((point) => (
            <ModalProvider key={point?.id ?? generateKey()}>
              <ProductButton point={point} />
            </ModalProvider>
          ))}
      </>
    )
  );
};
export default ImageRightPoints;
